const useForms = () => {
    const patchFormValues = <T extends Record<string, any>>(source: T, setFormData: Function, setValue: Function): void => {
        for(let key in source){
            setValue(key, source[key], { shouldValidate: true });
        }
        setFormData({...source});
    }

    return{
        patchFormValues
    }
}


export default useForms;